import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router';

export interface Migalha {
  rotulo: string;
  para?: string;
}

/** Caminho até a tela atual (só em telas de detalhe; listas não precisam). */
export function Migalhas({ itens }: { itens: readonly Migalha[] }) {
  return (
    <nav aria-label="Caminho">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-texto-suave">
        {itens.map((item, i) => (
          <li key={item.rotulo} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="size-3.5 text-texto-fraco" aria-hidden />}
            {item.para ? (
              <Link to={item.para} className="hover:text-texto hover:underline">
                {item.rotulo}
              </Link>
            ) : (
              <span aria-current="page" className="text-texto">
                {item.rotulo}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
